(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadCall', LeadCall);

    LeadCall.$inject = ['$resource', 'DateUtils'];

    function LeadCall ($resource, DateUtils) {
        var resourceUrl =  'api/lead-calls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateTime = DateUtils.convertDateTimeFromServer(data.dateTime);
                        data.appointmentDate = DateUtils.convertDateTimeFromServer(data.appointmentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
